<template>
    <v-container
        class="ma-0 pa-0"
        fluid
    >
        <v-card>
            <v-row
                class="ma-0 pa-0"
                no-gutters
                v-show="populating == false && populatingFailure == false"
            >
                <v-form
                    ref="patientForm"
                    v-model="isValid"
                >
                    <v-card-text>
                        <v-container
                            class="pb-0"
                            fluid
                        >
                            <v-row class="pb-0">
                                <v-col
                                    cols="12"
                                    justify="start"
                                >
                                    <v-btn
                                        @click="loadIdentityFindAddForm"
                                        class="text-none"
                                        color="light-blue darken-1"
                                        dark
                                        v-if="!patient.identityId"
                                    >
                                        <v-icon
                                            dark
                                            left
                                        >mdi-account</v-icon>Specify Patient
                                    </v-btn>
                                    <v-btn
                                        @click="patient.identityId = null"
                                        class="text-none"
                                        color="light-blue darken-1"
                                        text
                                        v-else
                                    >
                                        <v-icon
                                            dark
                                            left
                                        >mdi-close</v-icon>Clear Patient
                                    </v-btn>
                                    <v-card
                                        @click="loadIdentityForm(patient.identity)"
                                        v-if="patient.identityId"
                                    >
                                        <v-card-text>
                                            {{ patient.identity.name }} {{ patient.identity.surname }}
                                            <br />
                                            <span v-if="identityTypes">
                                                {{
                                                identityTypes.find(
                                                (x) => x.key == patient.identity.identityTypeId
                                                )
                                                ? identityTypes.find(
                                                (x) => x.key == patient.identity.identityTypeId
                                                ).value
                                                : ""
                                                }}
                                            </span>
                                            <br />
                                            {{ patient.identity.identificationNumber }}
                                        </v-card-text>
                                    </v-card>
                                    <br />
                                    <div
                                        style="color: red"
                                        v-show="patient.identityId === 0"
                                    >Patient identity is required</div>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                    class="mb-0"
                                    :label="patient.isTransfer ? 'Transfer from another facility' : 'Primary from scene via EMS'"
                                    v-model="patient.isTransfer"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" v-show="patient.isTransfer">
                                    <v-text-field
                                    :rules="[!patient.isTransfer || requiredRule]"
                                    label="Transfer from facility"
                                    v-model="patient.transferFromFacility"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="patientTypes"
                                        :rules="[requiredRule]"
                                        @input="$refs.patientForm.validate()"
                                        item-text="value"
                                        item-value="key"
                                        label="Patient Type"
                                        v-model="patient.patientType"
                                    ></v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="
                patient.patientType != 1 &&
                patientIn.patientType != patient.patientType
              "
                                >
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(50)]"
                                        label="Authorization Code"
                                        v-model="authorizationToken"
                                    >
                                        <template v-slot:append>
                                            <v-btn
                                                :disabled="isLoading || isRequestingAuthToken"
                                                :loading="isRequestingAuthToken"
                                                @click="requestAuthorizationToken"
                                                class="text-none"
                                                color="light-blue darken-1"
                                                text
                                                v-if="
                      isRequestingAuthToken === true ||
                      isRequestingAuthToken === null
                    "
                                            >Request</v-btn>

                                            <v-btn
                                                @click.stop
                                                class="text-none"
                                                disabled
                                                text
                                                v-else
                                            >Requested</v-btn>
                                        </template>
                                    </v-text-field>
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="showAuthorizers"
                                        class="text-none"
                                        color="light-blue darken-1"
                                        text
                                    >
                                        <v-icon
                                            dark
                                            left
                                        >mdi-account</v-icon>Show Authorizers
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-if="patient.patientType === 1"
                                >
                                    <v-select
                                        :disabled="isLoading"
                                        :items="passengerPositions"
                                        :rules="[requiredRule]"
                                        clearable
                                        item-text="value"
                                        item-value="key"
                                        label="Passenger Position"
                                        v-model="patient.passengerPosition"
                                    ></v-select>
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="patient.patientType == 1 || patient.patientType == 2"
                                >
                                    <v-switch
                                        class="mb-0"
                                        label="Seatbelt"
                                        v-model="patient.seatbeltOn"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        min-width="290px"
                                        offset-y
                                        transition="scale-transition"
                                        v-model="admissionDateMenu"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :rules="[requiredRule]"
                                                clearable
                                                label="Incident Admission Date"
                                                prepend-icon="mdi-calendar-month"
                                                readonly
                                                v-bind="attrs"
                                                v-model="patient.admissionDate"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            @input="admissionDateMenu = false"
                                            color="secondary"
                                            v-model="patient.admissionDate"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-divider></v-divider>

                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Consent Form Available"
                                        v-model="patient.consentFormAvailable"
                                        v-show="!patient.consentFormFileId && !consentForm"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Consent Form"
                                        placeholder="Set Consent Form"
                                        v-model="consentForm"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getFile(patient.consentFormFileId, 'patient_' + patient.id + '_consentform_' + patient.consentFormFileId)"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="patient.consentFormFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-show="!consentFormAvailable"
                                >
                                    <div style="color: red">Consent form document file or availability required.</div>
                                </v-col>

                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Ambulance Report Available"
                                        v-model="patient.ambulanceReportAvailable"
                                        v-show="!patient.ambulanceReportFileId && !ambulanceReport"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Ambulance Report"
                                        placeholder="Set Ambulance Report"
                                        v-model="ambulanceReport"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getFile(patient.ambulanceReportFileId, 'patient_' + patient.id + '_ambulancereport_' + patient.ambulanceReportFileId)"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="patient.ambulanceReportFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    cols="12"
                                    v-show="!ambulanceReportAvailable"
                                >
                                    <div style="color: red">Ambulance report document file or availability required.</div>
                                </v-col>

                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Transfer Letter Available"
                                        v-model="patient.transferLetterAvailable"
                                        v-show="!patient.transferLetterFileId && !transferLetter"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Transfer Letter"
                                        placeholder="Set Transfer Letter"
                                        v-model="transferLetter"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getFile(patient.transferLetterFileId, 'patient_' + patient.id + '_transferletter_' + patient.transferLetterFileId)"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="patient.transferLetterFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>

                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Affidavit"
                                        placeholder="Set Affidavit"
                                        v-model="affidavit"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getFile(patient.affidavitFileId,'patient_' +patient.id +'_affidavit_' +patient.affidavitFileId)"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="patient.affidavitFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>

                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Patient Incident Report"
                                        placeholder="Set Patient Incident Report"
                                        v-model="patientIncidentReport"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getFile(patient.patientIncidentReportFileId,'patient_' +patient.id +'_incident-report_' +patient.patientIncidentReportFileId)"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="patient.patientIncidentReportFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <!--
                            Manual suspension switch added 2022-02-07
                            <v-col
                            cols="12"
                            v-if="userRoles.find(x => x == RoleType.Admin)"
                        >
                            <v-switch
                                class="mb-0"
                                label="Override Suspension (Account creation ignores document requirements)"
                                v-model="patient.overrideSuspension"
                            ></v-switch>
                                </v-col>-->
                                                                <v-col cols="12">
                                    <v-switch
                                        class="mb-0"
                                        label="Admin Funding Account"
                                        v-model="patient.isAdminAccount"
                                    ></v-switch>
                                </v-col>
                                <!--<v-col cols="12">
                                    <v-switch
                                        class="mb-0"
                                        label="Admitted"
                                        v-model="patient.isAdmitted"
                                    ></v-switch>
                                </v-col>-->

                                <v-expand-transition>
                                    <v-col
                                        class="my-0 py-0"
                                        cols="12"
                                        v-show="patient.isAdmitted"
                                    >
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <v-select
                                                    :disabled="isLoading"
                                                    :items="admittedProviders"
                                                    :rules="[!patient.isAdmitted || requiredRule]"
                                                    clearable
                                                    item-text="value"
                                                    item-value="key"
                                                    label="Admitted To Facility"
                                                    v-model="patient.admittedToServiceProviderId"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    min-width="290px"
                                                    offset-y
                                                    transition="scale-transition"
                                                    v-model="admittedDateMenu"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :rules="[!patient.isAdmitted || requiredRule]"
                                                            clearable
                                                            label="Admitted To Facility Date"
                                                            prepend-icon="mdi-calendar-month"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-model="patient.admittedToServiceProviderDate"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        @input="admittedDateMenu = false"
                                                        color="secondary"
                                                        v-model="patient.admittedToServiceProviderDate"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-switch
                                                    :disabled="isLoading"
                                                    class="mb-0"
                                                    label="Legal Consent Available"
                                                    v-model="patient.legalConsentAvailable"
                                                    v-show="!patient.legalConsentFileId && !legalConsent"
                                                ></v-switch>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn
                                                    class="text-none"
                                                    color="secondary darken-1"
                                                    href="http://app.erafsolutions.co.za/legalconsentform.pdf"
                                                    target="_blank"
                                                    text
                                                >Get Legal Consent Form</v-btn>
                                                <v-file-input
                                                    :disabled="isLoading"
                                                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                    label="Legal Consent"
                                                    placeholder="Set Legal Consent"
                                                    v-model="legalConsent"
                                                >
                                                    <template slot="append-outer">
                                                        <v-btn
                                                            @click.stop="getFile(patient.legalConsentFileId, 'patient_' + patient.id + '_legalconsent_' + patient.legalConsentFileId)"
                                                            elevation="1"
                                                            fab
                                                            small
                                                            v-show="patient.legalConsentFileId > 0"
                                                        >
                                                            <h3>
                                                                <v-icon color="light-blue">mdi-download</v-icon>
                                                            </h3>
                                                        </v-btn>
                                                    </template>
                                                </v-file-input>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-switch
                                                    :disabled="isLoading"
                                                    class="mb-0"
                                                    label="Attorney Mandate Available"
                                                    v-model="patient.attorneyMandateAvailable"
                                                    v-show="!patient.attorneyMandateFileId && !attorneyMandate"
                                                ></v-switch>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-file-input
                                                    :disabled="isLoading"
                                                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                    label="Attorney Mandate"
                                                    placeholder="Set Attorney Mandate"
                                                    v-model="attorneyMandate"
                                                >
                                                    <template slot="append-outer">
                                                        <v-btn
                                                            @click.stop="getFile(patient.attorneyMandateFileId, 'patient_' + patient.id + '_attorneymandate_' + patient.attorneyMandateFileId)"
                                                            elevation="1"
                                                            fab
                                                            small
                                                            v-show="patient.attorneyMandateFileId > 0"
                                                        >
                                                            <h3>
                                                                <v-icon color="light-blue">mdi-download</v-icon>
                                                            </h3>
                                                        </v-btn>
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-expand-transition>
                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading || !canEditIsVerified"
                                        label="Verified"
                                        v-model="patient.isVerified"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading || !canEditIsDischarged"
                                        label="Discharged from ER"
                                        v-model="patient.isDischarged"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading || !canEditIsFraudulent"
                                        label="Fraudulent"
                                        v-model="patient.isFraudulent"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading || !canEditIsSuspended"
                                        label="Suspended"
                                        v-model="patient.isSuspended"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    v-if="canEditIsFinalised"
                                >
                                    <v-switch
                                        :disabled="isLoading || !canEditIsFinalised"
                                        label="Finalised"
                                        v-model="patient.isFinalised"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row
                                align="end"
                                class="pt-5 pb-10"
                                justify="space-between"
                                no-gutters
                            >
                                <v-col cols="12">
                                    <v-card-subtitle class="ma-0 pa-0">
                                        <strong>Member Id: {{patient.mediKreditAddCardId > 0 ? patient.id : "n/a"}}</strong>
                                    </v-card-subtitle>
                                </v-col>

                                <v-col cols="12">
                                    <v-btn
                                        :disabled="(isLoading && !isMedikreditAdding) || patient.mediKreditAddCardId > 0 "
                                        :loading="isMedikreditAdding"
                                        @click="medikreditAdd"
                                        class="text-none"
                                        color="secondary darken-1"
                                        v-show="patient.id > 0"
                                    >Add To MediKredit</v-btn>
                                </v-col>
                            </v-row>

                            <v-row
                                align="end"
                                class="pt-5 pb-10"
                                justify="space-between"
                                no-gutters
                                v-if="canDownloadPatientLog"
                            >
                                <v-col cols="12">
                                    <v-btn
                                        :disabled="isLoading"
                                        :loading="isGettingPatientLog"
                                        @click="getPatientLog"
                                        class="text-none"
                                        color="secondary darken-1"
                                        v-show="patient.id > 0"
                                    >Get Patient Log</v-btn>
                                </v-col>
                            </v-row>
                            <v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                            >
                                <v-btn
                                    :disabled="isLoading && !isDeleting"
                                    :loading="isDeleting"
                                    @click="deleteEntity"
                                    class="text-none"
                                    color="warning darken-1"
                                    text
                                    v-show="patient.id > 0"
                                >Delete</v-btn>
                                <v-btn
                                    :disabled="isLoading"
                                    @click="closeForm"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                >Close</v-btn>
                                <v-btn
                                    :disabled="isLoading && !isSaving"
                                    :loading="isSaving"
                                    @click="saveEntity"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                >{{ patient.id > 0 ? "Update" : "Add" }}</v-btn>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
                <v-snackbar
                    :color="notifyColor"
                    :timeout="15000"
                    top
                    v-model="notifyShow"
                >
                    {{ notifyMessage }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                            @click="notifyShow = false"
                            class="text-none"
                            icon
                            v-bind="attrs"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-snackbar>

                <v-dialog
                    v-model="authorizersShow"
                    width="500px"
                >
                    <v-card>
                        <v-card-title>Provider Patient Authorizers</v-card-title>
                        <v-card-text>
                            <template v-if="patientAuthorizers && patientAuthorizers.length > 0">
                                <v-list-item
                                    :key="index"
                                    two-line
                                    v-for="(autho, index) in patientAuthorizers"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>{{ autho.key }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ autho.value }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <span v-else>No Authorizers are registered for this provider.</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                @click="authorizersShow = false"
                                class="text-none"
                                color="secondary darken-1"
                                text
                            >Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog
                    persistent
                    v-model="identityFindAddFormVisible"
                    width="500px"
                >
                    <IdentityFindAddForm
                        :allowDeceased="true"
                        :key="identityFindAddFormKey"
                        @close="closeIdentityFindAddForm"
                        @located="locatedIdentity"
                    />
                </v-dialog>

                <v-dialog
                    persistent
                    v-model="identityFormVisible"
                    width="500px"
                >
                    <IdentityForm
                        :hide-delete="true"
                        :identity-in="identityFormIdentity"
                        :key="identityFormKey"
                        @close="closeIdentityForm"
                        @saved="updateIdentity"
                    />
                </v-dialog>
            </v-row>
            <v-row
                class="ma-0 pa-0"
                no-gutters
                v-show="populating == true"
            >
                <v-col
                    class="text-center"
                    cols="12"
                >
                    <v-progress-circular
                        :size="50"
                        color="secondary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
            <v-row
                class="ma-0 pa-0"
                no-gutters
                v-show="populating == false && populatingFailure == true"
            >
                <v-col
                    class="text-center"
                    cols="12"
                >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
//import Patient from "../../models/Patient.model";
import IdentityFindAddForm from "./IdentityFindAddForm";
import Patient from "../../models/Patient.model";
import Identity from "../../models/Identity.model";
import IdentityForm from "./IdentityForm";
import EntityType from "../../constants/EntityType.constant";
import dateToString from "../../helpers/dateToString";
import RoleType from "../../constants/RoleType.constant";
import uuid4 from "../../helpers/uuid4";
import fileDownload from "js-file-download";

export default {
    mounted: async function() {
        await this.loadPatient();

        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.patientTypes = await this.$store.dispatch("patients/getTypes");
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
        this.admittedProviders = await this.$store.dispatch(
            "providers/getlistaccicarefacilities",
            this.patientIn.admittedToServiceProviderId ?? 0
        );
    },
    created: async function() {},
    props: {
        patientId: {
            type: Number,
            default: 0
        },
        incidentId: {
            type: Number,
            default: 0
        },
        providerId: {
            type: Number,
            default: 0
        }
    },
    components: {
        IdentityFindAddForm,
        IdentityForm
        //
    },

    computed: {
        consentFormAvailable: function() {
            if (this.patient.consentFormFileId > 0) return true;

            if (!!this.consentForm || this.patient.consentFormAvailable)
                return true;

            return false;
        },
        ambulanceReportAvailable: function() {
            if (this.patient.ambulanceReportFileId > 0) return true;

            if (!!this.ambulanceReport || this.patient.ambulanceReportAvailable)
                return true;

            return false;
        },
        canEditIsVerified: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        canEditIsDischarged: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        canEditIsSuspended: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        canEditIsFraudulent: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        canEditIsFinalised: function() {
            return this.userRoles.some(x => x == RoleType.Admin);
        },
        canDownloadPatientLog: function() {
            return this.userRoles.some(x => x == RoleType.Admin);
        }
    },

    data() {
        return {
            patientIdValue: this.patientId,
            populating: true,
            populatingFailure: true,

            passengerPositions: [
                { key: 1, value: "Front" },
                { key: 2, value: "Back" }
            ],

            patient: {},
            patientIn: {},
            identityTypes: [],
            patientTypes: [],
            userRoles: [],
            isValid: false,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",

            admissionDateMenu: false,

            identityFindAddFormVisible: false,
            identityFindAddFormKey: 0,
            identityFindAddFormTarget: null,

            authorizationToken: "",
            isRequestingAuthToken: null,

            patientFormKey: null,
            patientFormVisible: false,

            consentForm: null,
            ambulanceReport: null,
            transferLetter: null,
            affidavit: null,
            patientIncidentReport: null,
            legalConsent: null,
            attorneyMandate: null,

            //identity form
            identityFormVisible: false,
            identityFormKey: 0,
            identityFormIdentity: new Identity(),

            patientAuthorizers: [],
            authorizersShow: null,
            RoleType: RoleType,

            admittedDateMenu: false,
            admittedProviders: [],

            isMedikreditAdding: false,
            isGettingPatientLog: false
        };
    },
    methods: {
        async loadPatient() {
            this.populating = true;
            this.populatingFailure = true;

            if (this.patientIdValue > 0) {
                var requestId = (this.requestId = uuid4());
                var patientResponse = await this.$store.dispatch(
                    "patients/get",
                    {
                        id: this.patientIdValue,
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == patientResponse.requestId &&
                    patientResponse.data.entity.id == this.patientIdValue
                ) {
                    this.clearUploadInputs();
                    this.patientIn = patientResponse.data.entity;
                    this.patient = new Patient().set(this.patientIn);
                    this.populatingFailure = false;
                }
            } else if (this.patientIdValue === 0) {
                this.patient = new Patient();
                this.patient.id = this.patientIdValue;
                this.patient.incidentId = this.incidentId;
                this.populatingFailure = false;
            }
            this.getDateTimeValuesFromPatient();
            this.populating = false;
        },
        getDateTimeValuesFromPatient() {
            this.patient.admissionDate = dateToString(
                this.patient.admissionDate
                    ? new Date(this.patient.admissionDate)
                    : null
            );

            this.patient.admittedToServiceProviderDate = dateToString(
                this.patient.admittedToServiceProviderDate
                    ? new Date(this.patient.admittedToServiceProviderDate)
                    : null
            );
        },
        clearUploadInputs() {
            this.consentForm = null;
            this.ambulanceReport = null;
            this.transferLetter = null;
            this.affidavit = null;
            this.patientIncidentReport = null;
            this.legalConsent = null;
            this.attorneyMandate = null;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //subform handleser --------------------------------------------------------
        /*loadPatientForm(patient) {
      this.identityFindAddFormKey = patient.id;
      this.patientFormVisible = true;
    },*/
        loadIdentityFindAddForm() {
            this.identityFindAddFormKey += 1;
            this.identityFindAddFormVisible = true;
        },
        closeIdentityFindAddForm() {
            this.identityFindAddFormVisible = false;
        },
        locatedIdentity(identity) {
            this.patient.identityId = identity.id;
            this.patient.identity = identity;
        },
        showAuthorizers() {
            this.$store
                .dispatch("providers/getPatientAuthorizers", this.providerId)
                .then(
                    response => {
                        this.patientAuthorizers = response;
                        this.authorizersShow = true;
                        //  this.notify(
                        //     (response && response.length > 0)? response.reduce((x, a) => x + "<br>" + a.key + ": " + a.value, "" ) : "No Authorizers are registered for this provider.",
                        //    "secondary"
                        //);
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.deleteEntityDone);
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedPatient) {
            this.$emit("saved", savedPatient);
        },
        emitDeletedEntity(deletedPatient) {
            this.$emit("deleted", deletedPatient);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        emitSavedIdentity(savedIdentity) {
            this.$emit("savedIdentity", savedIdentity);
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            //this.isValid = this.$refs.patientForm.validate();

            this.$refs.patientForm.validate();

            if (!(this.patient.identityId > 0)) this.patient.identityId = 0;
/*
            if(this.patient.isTransfer && !this.patient.transferFromFacility) {
                this.notify("Tranfer from facility required.", 'error');
                return;
            }
*/
            return (
                this.isValid &&
                this.patient.identityId > 0 &&
                this.consentFormAvailable &&
                this.ambulanceReportAvailable
            );
        },

        //request authorization toke ------------------------------------------------------------
        requestAuthorizationToken() {
            this.isRequestingAuthToken = true;
            var isNew = !(this.patient.id > 0);

            this.$store
                .dispatch("authorizationTokens/requestNew", {
                    entityType: EntityType.Patient,
                    entityId: isNew ? this.patient.incidentId : this.patient.id,
                    isNewEntity: isNew
                })
                .then(
                    () => {
                        this.notify(
                            "Token request sent. An area supervisor will contact you.",
                            "success"
                        );
                        this.isRequestingAuthToken = false;
                    },
                    error => {
                        this.notify(error.response.data, "error");
                        this.isRequestingAuthToken = null;
                    }
                );
        },

        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("ConsentForm", this.consentForm);
                formdata.append("AuthorizationToken", this.authorizationToken);
                formdata.append("AmbulanceReport", this.ambulanceReport);
                formdata.append("TransferLetter", this.transferLetter);
                formdata.append("Affidavit", this.affidavit);
                formdata.append("LegalConsent", this.legalConsent);
                formdata.append("AttorneyMandate", this.attorneyMandate);

                formdata.append(
                    "PatientIncidentReport",
                    this.patientIncidentReport
                );
                formdata.append("Model", JSON.stringify(this.patient));

                const parameters = {
                    id: this.patient.id,
                    formData: formdata
                };

                this.$store
                    .dispatch(
                        "patients/" +
                            (this.patient.id == 0 ? "create" : "update"),
                        this.patient.id == 0 ? parameters.formData : parameters
                    )
                    .then(
                        patientWithInfo => {
                            this.notify(
                                "Patient successfully saved.",
                                "success"
                            );
                            if (this.patientIdValue == 0) {
                                this.patient.id = patientWithInfo.entity.id;
                                this.patientIdValue = this.patient.id;
                            }
                            this.clearUploadInputs();
                            //this.patientIn.patientType = this.patient.patientType;

                            //this.consentForm = this.authorizationToken = this.ambulanceReport = this.transferLetter = this.affidavit = null;
                            /*
                            this.patient.affidavitFileId =
                                patientWithInfo.entity.affidavitFileId;
                            this.patient.patientIncidentReportFileId =
                                patientWithInfo.entity.patientIncidentReportFileId;
                                */
                            this.emitSavedEntity(patientWithInfo);
                            this.loadPatient();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this patient?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("patients/delete", this.patient.id)
                    .then(
                        () => {
                            this.notify(
                                "Patient successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.patient);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        getPatientLog() {
            this.isLoading = true;
            this.isGettingPatientLog = true;
            this.$store
                .dispatch("reports/getpatientlog", {
                    patientId: this.patient.id
                })
                .then(
                    response => {
                        this.notify("Downloading...", "success", 3000);
                        fileDownload(
                            response.data,
                            response.headers["content-disposition"].match(
                                /filename\s*=\s*(.+);/i
                            )[1]
                        );
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.getPatientLogDone);
        },
        getPatientLogDone() {
            this.isLoading = false;
            this.isGettingPatientLog = false;
        },
        //medikredit add        ------------------------------------------------------------
        medikreditAdd() {
            this.isLoading = true;
            this.isMedikreditAdding = true;
            this.$store
                .dispatch("patients/medikreditadd", this.patient.id)
                .then(
                    () => {
                        this.notify("Patient successfully added.", "success");
                        this.patient.mediKreditAddCardId = 1;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.medikreditAddDone);
        },
        medikreditAddDone() {
            this.isLoading = false;
            this.isMedikreditAdding = false;
        },

        //IdentityForm Methods
        loadIdentityForm(identity) {
            this.identityFormIdentity = new Identity().set(identity);
            this.identityFormKey = identity.id;
            this.identityFormVisible = true;
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        },
        updateIdentity(entity) {
            this.patient.identity = entity.entity;
            this.emitSavedIdentity(entity);
        }
    }
};
</script>

<style lang="stylus" scoped></style>